import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'valueArray',
})
export class ValueArrayPipe implements PipeTransform {


  transform(objects : any = []) {

    console.log('l\'objet concerné : ', objects, Object.values(objects))
    return Object.values(objects);
  }
}